"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getColorByName = exports.colors = void 0;
var common_styles_1 = require("@next-components/common-styles");
exports.colors = [
    {
        name: 'darkBlue',
        value: common_styles_1.bosColor.darkBlue,
    },
    {
        name: 'turquoise',
        value: common_styles_1.bosColor.turquoise,
    },
    {
        name: 'ultramarine',
        value: common_styles_1.bosColor.ultramarine,
    },
    {
        name: 'blue',
        value: common_styles_1.bosColor.blue,
    },
    {
        name: 'oker',
        value: common_styles_1.bosColor.oker,
    },
    {
        name: 'komorebi',
        value: common_styles_1.bosColor.komorebi,
    },
    {
        name: 'poppy',
        value: common_styles_1.bosColor.poppy,
    },
    {
        name: 'concrete',
        value: common_styles_1.bosColor.concrete,
    },
    {
        name: 'turquoise60',
        value: common_styles_1.bosColor.turquoise60,
    },
    {
        name: 'blue60',
        value: common_styles_1.bosColor.blue60,
    },
    {
        name: 'oker60',
        value: common_styles_1.bosColor.oker60,
    },
    {
        name: 'komorebi60',
        value: common_styles_1.bosColor.komorebi60,
    },
    {
        name: 'poppy60',
        value: common_styles_1.bosColor.poppy60,
    },
    {
        name: 'turquoise20',
        value: common_styles_1.bosColor.turquoise20,
    },
    {
        name: 'blue20',
        value: common_styles_1.bosColor.blue20,
    },
    {
        name: 'oker20',
        value: common_styles_1.bosColor.oker20,
    },
    {
        name: 'komorebi20',
        value: common_styles_1.bosColor.komorebi20,
    },
    {
        name: 'poppy20',
        value: common_styles_1.bosColor.poppy20,
    },
    {
        name: 'black',
        value: common_styles_1.bosColor.black,
    },
    {
        name: 'white',
        value: common_styles_1.bosColor.white,
    },
    {
        name: 'darkGrey',
        value: common_styles_1.bosColor.darkGrey,
    },
    {
        name: 'neutralPlus',
        value: common_styles_1.bosColor.neutralPlus,
    },
    {
        name: 'neutralGrey',
        value: common_styles_1.bosColor.neutralGrey,
    },
    {
        name: 'lightGrey',
        value: common_styles_1.bosColor.lightGrey,
    },
];
exports.getColorByName = function (colorVariant) {
    var color = exports.colors.find(function (c) { return c.name === colorVariant; });
    return color === null || color === void 0 ? void 0 : color.value;
};
//# sourceMappingURL=colorByName.js.map